import type { PMPluginFactoryParams } from '@atlaskit/editor-common/types';
import { type NodeType } from '@atlaskit/editor-prosemirror/model';
import { DecorationSet } from '@atlaskit/editor-prosemirror/view';

import type { EditorPluginAIConfigItem } from '../../ui/prebuilt/config-items/config-items';
import type {
	InvokedFrom,
	InvokedFromTriggerMethod,
} from '../../ui/utils/analytics/analyticsFlowTypes';
import type { Positions } from '../../ui/utils/xstate/get-ai-experience-service';

export interface EndExperienceAction {
	type: 'END_EXPERIENCE';
	data: { modalDecorationSet?: DecorationSet };
}
export interface ShowModalAction {
	type: 'SHOW_MODAL';
	data: {
		modalDecorationSet: DecorationSet;
		configItem: EditorPluginAIConfigItem;
		modalMountedTimeStamp: number;
		lastTriggeredFrom?: InvokedFrom;
		triggerMethod?: InvokedFromTriggerMethod;
		initialPrompt?: string;
		triggeredFor?: NodeType;
		initialPositions: Positions;
		nudgeMetrics?: Record<string, number | undefined>;
	};
}

export interface AIDecorationExperiencePluginState {
	dispatchAnalyticsEvent: PMPluginFactoryParams['dispatchAnalyticsEvent'];
	modalDecorationSet: DecorationSet;
	configItem?: EditorPluginAIConfigItem;
	modalMountedTimeStamp?: number;
	lastTriggeredFrom?: InvokedFrom;
	triggerMethod?: InvokedFromTriggerMethod;
	initialPrompt?: string;
	triggeredFor?: NodeType;
	initialPositions?: Positions;
	/**
	 * Nudge metrics will be used passed in analytics events.
	 * It includes detailed metrics for improve writing nudge.
	 */
	nudgeMetrics?: Record<string, number | undefined>;
}

export function reducer(
	state: AIDecorationExperiencePluginState,
	action: EndExperienceAction | ShowModalAction,
): AIDecorationExperiencePluginState {
	switch (action.type) {
		case 'END_EXPERIENCE':
			// When the experience ends the plugin state needs to reset everything back to the initial plugin state
			return {
				modalDecorationSet: DecorationSet.empty,
				dispatchAnalyticsEvent: state.dispatchAnalyticsEvent,
				initialPositions: undefined,
				...action.data,
			};
		case 'SHOW_MODAL':
			return {
				...state,
				...action.data,
			};

		default:
			return state;
	}
}
